<template>
  <b-dropdown aria-role="list" position="is-bottom-left">
    <p
      class="user-menu-icon button button-navbar is-hidden-mobile is-hidden-tablet-only"
      slot="trigger"
      role="button"
      aria-label="User menu"
    >
      <b-icon pack="fas" icon="user" size="is-medium"> </b-icon>
    </p>
    <p
      class="button is-primary more-button is-hidden-desktop"
      slot="trigger"
      role="button"
      aria-label="More button"
    >
      <span class="icon">
        <i class="fas fa-ellipsis-h"></i>
      </span>
      <span>More</span>
    </p>
    <b-dropdown-item custom>
      <a href="/app/how-to-add" style="background-color: white">
        <img
          src="https://platform.slack-edge.com/img/add_to_slack.png"
          alt="Add to Slack"
          height="28"
        />
      </a>
      <br />
      Required to use <b>/map</b> command
    </b-dropdown-item>
    <hr class="dropdown-divider" aria-role="menuitem" />
    <b-dropdown-item
      id="privacy-policy-button"
      aria-role="listitem"
      is-danger
      href="/privacy.html"
      aria-label="Privacy Policy"
    >
      <span class="is-vertical-center">
        Privacy Policy
      </span>
    </b-dropdown-item>
    <b-dropdown-item
      id="tos-button"
      aria-role="listitem"
      is-danger
      href="/tos.html"
      aria-label="Terms of Service"
    >
      <span class="is-vertical-center">
        Terms of Service
      </span>
    </b-dropdown-item>
    <hr class="dropdown-divider" aria-role="menuitem" />
    <b-dropdown-item
      id="logout-button"
      aria-role="listitem"
      is-danger
      href="/app/logout"
      aria-label="Logout"
    >
      <span class="is-vertical-center">
        Logout
      </span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "user-menu"
};
</script>

<style scoped>
.user-menu-icon {
  font-size: 0.75rem;
  border-radius: 100%;
  height: 44px;
  width: 44px;
  color: #b1b1b1;
  background-color: #e8eaed;
  border: 0px;
}

.user-menu-icon:hover {
  color: #b1b1b1;
  background-color: #e8eaed;
  border: 2px solid #d3d3d3;
}

.more-button {
  padding-left: 5px;
  padding-right: 5px;
  color: #6b6b6b;
  background-color: white;
}

.more-button:hover {
  color: #363636;
  background-color: white;
}
</style>
